export default __webpack_public_path__ + "static/media/Bot-Work-In-Progress-3.85ac834e.jpg";